module.exports = __webpack_public_path__ + "img/grid-srp-preview-honda.b5e49907.png";